import React from 'react';

export const AssignmentFunctionPicker = ({ prefix, value, onChange, disabled, showHint = false }) => (
  <div>
    <p className="text-xs font-medium text-slate-600 mb-1" data-testid={`${prefix}-funcion-label`}>
      Función en el activo
      {showHint && <span className="ml-1 text-slate-400 font-normal">— no cambia el rol global del usuario</span>}
    </p>
    <div className="inline-flex rounded-md border border-slate-200 bg-slate-50 p-0.5 gap-0.5" role="group" aria-label="Función en el activo" data-testid={`${prefix}-funcion`}>
      {[
        ['gestor', 'Gestor', 'text-blue-700 bg-blue-100 border-blue-300'],
        ['mediador', 'Mediador', 'text-amber-700 bg-amber-100 border-amber-300'],
        ['inversor', 'Inversor', 'text-emerald-700 bg-emerald-100 border-emerald-300'],
      ].map(([key, label, colors]) => (
        <button key={key} type="button" onClick={() => onChange(key)} disabled={disabled}
          aria-pressed={value === key} data-testid={`${prefix}-funcion-${key}`}
          className={`px-3 py-1.5 text-xs font-medium rounded transition-colors border ${value === key ? colors : 'border-transparent text-slate-500 hover:text-slate-700 hover:bg-white'}`}>
          {label}
        </button>
      ))}
    </div>
  </div>
);